export default {
  name: 'hunan',
  adcode: '430000',
  mapName: '湖南省',
  geoJsonPath: 'china-geojson/src/geojson/hu_nan_geo.json',
  backgroundImage: {
    png: 'hunan_map.png',
    webp: 'hunan_map.webp'
  },
  echartsMapStyle: {
    width: '775px',
    height: '775px',
    marginTop: 'auto'
  },
  imageSize: {
    width: 3606,
    height: 3618
  },
  // 省级城市列表
  cities: ['长沙市', '岳阳市', '益阳市', '郴州市', '怀化市', '邵阳市', '株洲市', '张家界市', '湘西土家族苗族自治州', '永州市', '湘潭市', '衡阳市', '娄底市', '常德市'],
  // 城市坐标映射（用于tooltip定位与涟漪效果）
  cityCoords: {
    '长沙市': [112.888814, 28.328209],
    '岳阳市': [112.9696, 28.9753856],
    '常德市': [111.291347, 29.101005],
    '衡阳市': [112.241, 26.8598],
    '株洲市': [113.334002, 27.527],
    '湘潭市': [112.241, 27.80009],
    '益阳市': [111.455, 28.460017],
    '邵阳市': [110.521, 26.9638],
    '张家界市': [110.2079, 29.4127],
    '怀化市': [109.628, 27.52095],
    '娄底市': [111.0628, 27.849],
    '永州市': [111.493, 25.819],
    '郴州市': [112.806, 25.827],
    '湘西土家族苗族自治州': [109.268, 28.8411],
    // 别名兼容
    '湘西州': [109.268, 28.8411],
    '湘西土家族自治州': [109.268, 28.8411],
  },
  // 城市名称标准化
  normalizeName: (name) => {
    if (!name) return ''
    const s = String(name).trim()
    if (s === '湘西州' || s === '湘西土家族自治州') return '湘西土家族苗族自治州'
    return s
  },
  // 城市与adcode映射
  cityAdcodeMap: {
    '长沙市': '430100',
    '株洲市': '430200',
    '湘潭市': '430300',
    '衡阳市': '430400',
    '邵阳市': '430500',
    '岳阳市': '430600',
    '常德市': '430700',
    '张家界市': '430800',
    '益阳市': '430900',
    '郴州市': '431000',
    '永州市': '431100',
    '怀化市': '431200',
    '娄底市': '431300',
    '湘西土家族苗族自治州': '433100'
  }
}